module.exports = __webpack_public_path__ + "static/img/soft_6.c8b5432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/soft_6.png
// module id = 4D6a
// module chunks = 0